<kendo-dialog title="Unlocking Tier" (close)="onCancel()">
  <div class="unlock-tier-confirmation-message">
    <p>
      This action will unlock tier <strong>{{ tierToUnlock.name }}</strong
      >.
    </p>

    <p>All pending/scheduled/failed changes to this tier will be canceled.</p>
    <p>Are you sure you want to proceed?</p>
  </div>

  <kendo-dialog-actions>
    <button kendoButton (click)="onCancel()">No</button>
    <button kendoButton (click)="onProceed()" themeColor="primary">Yes</button>
  </kendo-dialog-actions>
</kendo-dialog>
